import { createStyles, makeStyles } from '@hawkins/styles';
export var popoverStyles = function () {
    return createStyles({
        /** Class name applied to the root of the popover */
        root: {},
        /** Class name applied to the paper element for the popover */
        paper: {
            padding: 0,
        },
        /** Class name applied to the paper root element of the popover when it opens top */
        top: {},
        /** Class name applied to the paper root element of the popover when it opens bottom */
        bottom: {},
        /** Class name applied to the paper root element of the popover when it opens left */
        left: {},
        /** Class name applied to the paper root element of the popover when it opens right */
        right: {},
        /** Class name applied to the popover trigger container */
        popoverTriggerContainer: {},
        /** Class name applied to the popover trigger container when fullWidth = true */
        popoverTriggerContainerFullWidth: {
            width: '100%',
        },
    });
};
export var usePopoverStyles = makeStyles(popoverStyles(), { name: 'Hawkins-Popover' });
